var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.136 16.4328C20.7041 17.1134 20.2059 17.7468 19.6492 18.3253C18.1154 19.922 16.1417 21.0946 13.9247 21.6495C12.9885 21.8842 12.0078 22.009 10.9983 22.009C10.9373 22.009 10.8753 22.0081 10.8142 22.0073C10.4329 22.002 10.0569 21.9785 9.68521 21.9375C8.8319 21.845 8.00563 21.6626 7.21602 21.4009C4.51474 20.5039 2.23925 18.6743 0.773438 16.2924L0.848473 16.1571L1.21405 15.4984C1.79078 14.4583 2.80288 13.7307 3.97291 13.5169L5.57309 13.2246L7.17326 12.9332H7.17414L7.37045 12.8974L8.22376 12.7413L8.24994 12.7369L8.64082 12.6654L10.9599 12.2422L12.5994 12.5781H12.6011L13.0225 12.6654L13.5809 12.7805L13.6647 12.798H13.6656L14.4168 12.9515L16.2936 13.3372L17.1477 13.5117L18.1267 13.7132C19.0219 13.8965 19.8124 14.3798 20.3804 15.0639C20.6447 15.3806 20.8611 15.7409 21.0173 16.1344L21.136 16.4328Z",
    fill: "#05D484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67 9.96181V12.6648C13.67 13.6883 12.8411 13.8261 11.8177 13.8261H9.81615C8.95062 13.8261 8.25 13.8165 8.25 12.951V9.96094H13.67V9.96181Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1381 16.4257C20.7062 17.1063 20.208 17.7397 19.6514 18.3182L18.3906 16.2696C17.9133 15.4948 17.1482 14.9416 16.2634 14.7305L12.4375 13.8213L13.584 12.7734L13.6677 12.7909H13.6686L14.4198 12.9444L16.2966 13.3301L17.1508 13.5046L18.1297 13.7061C19.0249 13.8894 19.8154 14.3727 20.3834 15.0568C20.6478 15.3735 20.8642 15.7339 21.0203 16.1274L21.1381 16.4257Z",
    fill: "url(#paint0_linear_7220_2186)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6704 11.9715L10.3906 13.8203L12.1068 15.226L14.316 13.084C14.4146 12.9888 14.4722 12.8588 14.4757 12.7227C14.4853 12.3973 14.3928 11.8197 13.6704 11.6016V11.9715Z",
    fill: "#122240"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3928 13.8212L8.75078 15.0637L7.28497 13.1982C7.15933 13.0386 7.13577 12.8205 7.22738 12.639C7.42632 12.242 7.81545 11.6016 8.25171 11.6016V12.7332L10.3928 13.8212Z",
    fill: "#122240"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 10.6947L8.25 11.3788V9.96094H9.95488L11.918 10.6947Z",
    fill: "#122240"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6738 10.8613H9.25369C7.91439 10.8613 6.82812 9.77592 6.82812 8.43575V4.01562H13.6738V10.8613Z",
    fill: "#EEEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5637 4.89519C14.5637 5.77904 14.7582 6.37757 14.3298 6.88013C13.7767 7.5284 12.8579 7.28498 12.8047 7.27189C12.8047 6.40811 12.8047 5.54346 12.8047 4.67969C13.391 4.75211 13.9773 4.82365 14.5637 4.89519Z",
    fill: "#122240"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5621 4.89913H5.78906V4.73859C5.78906 4.46288 5.95048 4.2116 6.20263 4.0973L7.37789 3.56333C7.37789 3.56333 7.62569 2.07222 7.62656 2.0696C7.75743 1.2826 8.70323 1.06273 9.36546 0.965008C10.3505 0.8193 11.3469 0.82279 12.3285 0.985076C12.4114 0.998163 12.4951 1.01387 12.578 1.02957C13.2001 1.14911 14.3448 1.30092 14.3448 2.15598L14.5621 4.89913Z",
    fill: "#05D484"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5617 4.89844H13.2355L12.8822 2.47723C12.8298 2.11776 12.7208 1.76963 12.5585 1.44506L12.3281 0.984375C12.411 0.997463 12.4948 1.01317 12.5777 1.02887C13.1998 1.14841 14.3445 1.30022 14.3445 2.15528L14.5617 4.89844Z",
    fill: "url(#paint1_linear_7220_2186)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3731 6.65957C13.4098 6.61681 13.6279 6.36466 14.079 6.38385C14.428 6.39869 14.7918 6.61332 14.8939 6.93353C15.0667 7.47711 14.38 8.00497 14.2622 8.09484C13.9141 8.36183 13.5467 8.43686 13.3461 8.4613C13.3321 7.88369 13.3862 7.23629 13.3731 6.65957Z",
    fill: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7220_2186",
    x1: 19.6603,
    y1: 13.0962,
    x2: 15.6677,
    y2: 16.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7220_2186",
    x1: 13.8802,
    y1: 1.02146,
    x2: 12.9948,
    y2: 4.92541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverMsg);
export default __webpack_public_path__ + "static/media/DriverMsg.7216f872.svg";
export { ForwardRef as ReactComponent };